module.exports = __webpack_public_path__ + "static/media/icon-calendar-2.f44673ce.svg";